import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDAutocomplete from "components/MDAutocomplete";
import MDButton from "components/MDButton";
import { useFormik } from "formik";
import FormField from "layouts/pages/account/components/FormField";
import React, { useContext } from "react";
import MDLink from "components/MDLink";
import { ValidationSchema } from "layouts/pages/service-type/schemas/validationSchema";
import { InitialValues } from "layouts/pages/service-type/schemas/initialValues";
import { addServiceTypes } from "lib/Api/ServiceTypes";
import { LoginFormContext } from "context/loginFormCtx";
import RichTextEditor from 'components/common/RichTextEditor';

const AddServiceTypeForm = (props) => {
  const { setNotification } = useContext(LoginFormContext);

  const handleSubmit = async (values) => {
    let response = await addServiceTypes(values);

    if (response?.status === 200) {
      props?.setOpenAddForm(false);
      props?.getServiceTypeData();

      setNotification({
        color: "success",
        icon: "check",
        title: "Success",
        content: response.data.message,
        open: true,
      });
    } else {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: response.data.message,
        open: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema: ValidationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "2rem",
          }}
        >
          <Grid container spacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              <TextField
                variant="outlined"
                value={formik.values.name}
                error={Boolean(formik.touched.name && formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Name"
                fullWidth
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <RichTextEditor
                value={formik.values.description}
                onChange={(content) => formik.setFieldValue('description', content)}
                onBlur={() => formik.setFieldTouched('description', true)}
                error={Boolean(formik.touched.description && formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
              />
            </Grid>
          </Grid>

          <Grid container sx={{ justifyContent: "center", gap: "1rem" }}>
            <MDButton type="submit" color="primary" size="medium">
              Add Service Type
            </MDButton>
            <MDButton
              color="primary"
              variant="outlined"
              size="medium"
              onClick={() => props?.setOpenAddForm(false)}
            >
              Cancel
            </MDButton>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default AddServiceTypeForm;
